module.exports = __webpack_public_path__ + "assets/img/native.d981c0c1.webp";